import { render, staticRenderFns } from "./investigatingrequest.vue?vue&type=template&id=eef42a8a&scoped=true&"
import script from "./investigatingrequest.vue?vue&type=script&lang=js&"
export * from "./investigatingrequest.vue?vue&type=script&lang=js&"
import style0 from "./investigatingrequest.vue?vue&type=style&index=0&id=eef42a8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef42a8a",
  null
  
)

export default component.exports